import { ImageFade } from '@rikstv/play-common/src/components/imageFade/ImageFade';
import { LinkButton } from '@rikstv/play-common/src/components/linkButton/LinkButton';
import { H2 } from '@rikstv/shared-components';

import { urlFor } from '../../../../apis/sanity-image.utils';
import { StrimStartPageResponse } from '../../../../apis/sanityClient';
import { PortableTextToRDS } from '../../../../common/components/sanityComponents/blockContent';

import styles from './Plug.module.css';

export const Plug = ({ data }: { data: StrimStartPageResponse }) => {
  if (!data.plug) {
    return null;
  }

  const { plugImageUrl, plugTitle, plugText, plugButton } = data.plug;

  return (
    <section className={styles.plugWrapper}>
      <div className={styles.plug}>
        <div className={styles.plugMedia}>
          <div className={styles.imageGrid}>
            <picture>
              <ImageFade
                className={styles.players}
                src={urlFor(plugImageUrl).width(768).auto('format').url()}
                alt={plugTitle}
              />
            </picture>
          </div>
        </div>
        <div className={styles.plugTextWrapper}>
          <div className={styles.plugText}>
            <H2>{plugTitle}</H2>
            <PortableTextToRDS content={plugText} />
            {plugButton && (
              <LinkButton buttonStyle="highlighted" withArrow to={plugButton.link}>
                {plugButton.text}
              </LinkButton>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
